import React ,{useState,useEffect, useImperativeHandle}from 'react';
import '@/app/style/photoCaption.scss';
import { useLanguage } from "@/app/utils/LanguageContext";
import CaptionShowMore from './captionShowMore';
 
const PhotoCaption: React.FC<any> = (props: any) => {
  const {state:lang} = useLanguage();
  const {t} = lang;
  const {title,content, childRef,isDesktop, index} = props;
  useImperativeHandle(childRef, () => ({
    OnBackToCollapsed: () => {
        const elementsinput = document.querySelectorAll('input[name="input_caption_text"]:checked');
        elementsinput.forEach(function(checkbox) {
          const cbElement =  checkbox as HTMLInputElement;
          cbElement.checked = false;
        });

        setNavigationButtonDisplay('showless')
    },

  }))
  const setNavigationButtonDisplay =(value:string)=>{
    if(!isDesktop)
    {
      const elementsmain = document.getElementsByClassName('photos-swiper-main');
      if(elementsmain)
      {
        const elementsprev = document.getElementsByClassName('swiper-button-prev');
        const elementsnext = document.getElementsByClassName('swiper-button-next');
        const elementsactive = elementsmain?.[0]?.getElementsByClassName('swiper-slide-active');
        if(value=='showless')
        {
          elementsprev?.[0]?.classList.remove("photos-navigation-button-hide");
          elementsnext?.[0]?.classList.remove("photos-navigation-button-hide");
          elementsactive?.[0]?.classList.remove("swiper-gary-img");
        }else{
          elementsprev?.[0]?.classList.add("photos-navigation-button-hide");
          elementsnext?.[0]?.classList.add("photos-navigation-button-hide");
          elementsactive?.[0]?.classList.add("swiper-gary-img");
        }
      }
    }
  }

  return (
    (title!='' || content!='') ?
    <div className="caption_container">
      <div className="caption_title">{title}</div>
      <CaptionShowMore setNavigationButtonDisplay={setNavigationButtonDisplay} content={content} index={index} isDesktop={isDesktop} />
    </div>
    : <></>
  );
};
 
export default PhotoCaption